import * as React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setFetching, setVisibleTopPanel } from '~/Actions/ActionApp';
import IframeProxy from '~/api/IframeProxy';
import styles from '../../components/View/View.scss';
import { isMobileOrTabletWindow } from '~/utils/utils';
import { settings } from '~/utils/settings';
import Account from '~/account/Account';
import History from '~/utils/history';
import { urlsMap } from '~/utils/menu';
import classNames from 'classnames';
import { State } from '~/Reducers';

interface IStateSelector {
    isBlurView: boolean;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        isBlurView: state.ReducerApp.isBlurView,
    };
};

const DockyardContainer = () => {
    const dispatch = useDispatch();
    const [isVisible, setVisible] = React.useState<boolean>(false);
    const { isBlurView } = useSelector<State, IStateSelector>(stateSelector, shallowEqual);
    const ref: React.RefObject<HTMLIFrameElement> = React.createRef();

    const style: any = {
        width: '100%',
        height: !isMobileOrTabletWindow ? `100%` : 'calc(100% - 40px)',
        position: 'relative',
        top: isMobileOrTabletWindow ? '35px' : '-13px',
        display: isVisible ? 'block' : 'none',
    };

    React.useEffect(() => {
        if (!Account.getAccount()) {
            History.navigate(urlsMap.home);
            return;
        }

        dispatch(setVisibleTopPanel());
        dispatch(setFetching(true));

        const Proxy = new IframeProxy(dispatch, ref.current, () => {
            setVisible(true);
            dispatch(setFetching(false));
        });

        Proxy.listen();

        return () => {
            dispatch(setVisibleTopPanel(true));
            Proxy.remove();
        };
    }, []);

    const url = settings.urls.dockyard.replace('{lang}', settings.languageCode);

    return (
        <>
            <div
                className={classNames(styles.realPurchase, {
                    [styles.fullView]: isBlurView,
                })}
            >
                <iframe src={url} ref={ref} style={style} />
            </div>
        </>
    );
};

export default DockyardContainer;
